import styled from "styled-components";
import App from "../constants/app";

export const Footer = styled.div`
  flex: 0 0 auto;
  height: ${props => props.height || App.FOOTER_HEIGHT};
  background-color: ${props => props.theme.footer.background};
  width: 100%;
  z-index: 1;
`;

export const FooterContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: ${props => props.theme.footer.background};
`;

export const FooterContent = styled.div`
  height: ${props => props.height || App.FOOTER_HEIGHT};
  width: 50%;
  flex-basis: 50%;
  margin-right: 0;
`;



// WEBPACK FOOTER //
// ./app/styled-components/Footer.js